import * as React from "react";

import { usePrevious } from "../../../../../Helpers/ReactUtils/Hooks/UsePrevious";

import { LoadingBar, Root } from "./HorizontalLoader.styles";
import { UserFriendlyLoadingState } from "./UserFriendlyLoadingState";

export interface HorizontalLoaderProps {
    loadingState: UserFriendlyLoadingState;
}

export function HorizontalLoader(props: HorizontalLoaderProps): JSX.Element {
    const prevLoadingState = usePrevious(props.loadingState);
    let percentage = 0;
    let loaderSpeed: undefined | string;

    if (props.loadingState === UserFriendlyLoadingState.LoadingState1) {
        loaderSpeed = undefined;
        percentage = 0;
    } else if (props.loadingState === UserFriendlyLoadingState.LoadingState2) {
        loaderSpeed = undefined;
        percentage = 0;
    } else if (props.loadingState === UserFriendlyLoadingState.LoadingState3) {
        loaderSpeed = "1s";
        percentage = 60;
    } else if (props.loadingState === UserFriendlyLoadingState.LoadingState4) {
        loaderSpeed = "10s";
        percentage = 80;
    } else if (props.loadingState === UserFriendlyLoadingState.LoadingState5) {
        if (
            prevLoadingState === UserFriendlyLoadingState.LoadingState3 ||
            prevLoadingState === UserFriendlyLoadingState.LoadingState4
        ) {
            loaderSpeed = "0.05s";
            percentage = 100;
        } else {
            percentage = 0;
        }
    }

    return (
        <Root>
            <LoadingBar percentage={percentage} loaderSpeed={loaderSpeed} />
        </Root>
    );
}
